import styled from 'styled-components';
import { DEFAULT_TRANSITION_DURATION, DEFAULT_TRANSITION_FUNC } from '../../util/styled';
import { TABS_BUTTON, TABS_CONTAINER } from '../../util/data-id';

export const TabsStyled = styled('div')`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;  
  
  [data-id='${TABS_CONTAINER}'] {
   
  }
  
  [data-id='${TABS_BUTTON}'] {
    appearance: none !important;
    text-transform: uppercase;
    display: block;
    flex: 1 1 0%;
    height: ${(props) => props.theme.sizes.md};
    color: ${(props) => props.theme.colors.muted};
    background: ${(props) => props.theme.colors.light};
    border-top: 1px solid ${(props) => props.theme.colors.light};
    box-shadow: 0 -2px 5px 0px rgb(0 0 0 / 16%) inset;    
    transition: all ${DEFAULT_TRANSITION_FUNC} ${DEFAULT_TRANSITION_DURATION};
    
    &:hover {
      color: ${(props) => props.theme.colors.dark};
    }
  
    &:first-child {
      border-radius: ${(props) => props.theme.radius.default} 0 0 0;
      box-shadow: -2px -2px 5px 0px rgb(0 0 0 / 16%) inset;
    }
    
    &:last-child {
      border-radius: 0 ${(props) => props.theme.radius.default} 0 0;
      box-shadow: 2px -2px 5px 0px rgb(0 0 0 / 16%) inset;
    }
    
    &[aria-selected='true'] {
      box-shadow: none;
      font-weight: bold;
      color: ${(props) => props.theme.colors.dark};
      background: ${(props) => props.theme.colors.white};
    }
  }
`;
